module.exports = __webpack_public_path__ + "img/card_advisees.43233415.png";